export const CategorizedListItemTitle = ({ children }) => (
  <h1 className="mb-3 text-darkBlack text-2xl font-semibold pr-12">{children}</h1>
)
